import { EmptyItemSetQuestionOverlay } from '@exam-management/qcontent-management';
import { Flex, styled } from '@shared/components';
import { useMemo } from 'react';

import { QuestionPreviewCollapsible, useItemSetQuestionDetails } from '../..';
import { ItemSetSubQuestionMoreMenu } from '../item-set-sub-question-more-menu';

const Wrapper = styled(Flex)(({ theme }) => ({
  gap: theme.spacing(4),
  flexDirection: 'column',
}));

interface ItemSetSubQuestionPreviewProps {
  taskId: string;
}

export default function ItemSetSubQuestionPreview(props: Readonly<ItemSetSubQuestionPreviewProps>) {
  const { taskId } = props;
  const { itemSet } = useItemSetQuestionDetails();

  const { questions } = itemSet;

  const questionsWithQuestionGroup = useMemo(
    () =>
      [...(questions ?? [])]
        .map((question) => ({ ...question, questionGroup: itemSet }))
        .sort((a, b) => {
          return Number(a.groupOrder) - Number(b.groupOrder);
        }),
    [questions, itemSet],
  );

  if (!questions || questions.length === 0) {
    return <EmptyItemSetQuestionOverlay />;
  }

  return (
    <Wrapper>
      {questionsWithQuestionGroup.map((question) => (
        <QuestionPreviewCollapsible
          key={question.id}
          question={question}
          taskId={taskId}
          endAdornment={<ItemSetSubQuestionMoreMenu subQuestionId={question.id} taskId={taskId} />}
        />
      ))}
    </Wrapper>
  );
}
